"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "DiligentWordmark___StyledSvg",
  componentId: "sc-1clyyq8-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function DiligentWordmark(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 140 38",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    d: "M.189 28.811V.84h11.002c8.765 0 14.825 5.595 14.825 13.986 0 8.485-6.06 13.986-14.825 13.986H.19zm19.86-13.986c0-4.941-2.984-8.764-8.764-8.764H6.155V23.59h5.035c5.595 0 8.858-4.01 8.858-8.765zM28.907 3.17A3.144 3.144 0 0132.077 0a3.144 3.144 0 013.17 3.17 3.144 3.144 0 01-3.17 3.17c-1.678.094-3.17-1.398-3.17-3.17zm.56 5.408h5.314v20.233h-5.315V8.578zM44.571.84h-5.315V28.81h5.315V.84zM48.58 3.17A3.144 3.144 0 0151.75 0a3.144 3.144 0 013.17 3.17 3.144 3.144 0 01-3.17 3.17c-1.77.094-3.17-1.398-3.17-3.17zm.467 5.408h5.314v20.233h-5.314V8.578zM58.464 34.033l2.424-3.823c1.678 1.771 3.823 2.517 6.34 2.517 2.518 0 5.595-1.119 5.595-5.221v-1.958c-1.585 2.051-3.823 3.17-6.34 3.17-5.036 0-8.952-3.543-8.952-10.256 0-6.62 3.823-10.35 8.951-10.35 2.424 0 4.662 1.025 6.34 3.077V8.578h5.315v18.928c0 7.645-5.967 9.603-11.002 9.603-3.357 0-6.06-.839-8.671-3.076zm14.359-12.401v-6.62c-.933-1.306-2.89-2.238-4.57-2.238-3.076 0-5.127 2.144-5.127 5.594s2.144 5.595 5.128 5.595c1.678 0 3.636-1.026 4.569-2.331zM81.121 18.648c0-5.874 4.382-10.629 10.536-10.629 6.06 0 10.163 4.569 10.163 11.096v1.305H86.716c.373 2.517 2.424 4.569 5.874 4.569 1.678 0 4.102-.746 5.407-1.958l2.425 3.543c-2.051 1.865-5.222 2.797-8.392 2.797-6.247 0-10.909-4.196-10.909-10.723zm10.443-6.247c-3.357 0-4.755 2.331-4.942 4.29H96.6c-.187-1.865-1.492-4.29-5.035-4.29zM118.231 28.811V16.597c0-2.798-1.492-3.823-3.73-3.823-2.144 0-3.729 1.212-4.662 2.33v13.707h-5.315V8.578h5.315v2.61c1.305-1.491 3.823-3.076 7.086-3.076 4.476 0 6.62 2.517 6.62 6.433v14.36h-5.314v-.094zM129.14 23.776V13.24h-3.357V8.578h3.357v-5.5h5.315v5.5h4.102v4.662h-4.102v9.138c0 1.305.652 2.238 1.864 2.238.839 0 1.585-.28 1.865-.653l1.119 4.102c-.839.746-2.238 1.306-4.476 1.306-3.729 0-5.687-1.958-5.687-5.595z",
    fill: "#000"
  }));
}

var _default = DiligentWordmark;
exports["default"] = _default;